import React from 'react';
import './Motto.scss';
import lang from '../../i18/lang';

const Motto = props => (
    <div>
        <div className="element-motto">
            <h1>{lang.srb.section.element.t1}</h1>
        </div>
    </div>
);

export default Motto;